function JourneyFlowArrow() {
  return <span className="journey-flow-arrow" aria-hidden="true">→</span>;
}

function JourneyFlowGate({
  label,
  checked,
  disabled,
  title,
  onCheck,
}: {
  label: string;
  checked: boolean;
  disabled?: boolean;
  title?: string;
  onCheck?: () => void;
}) {
  const interactive = Boolean(onCheck) && !checked && !disabled;
  return (
    <label className="journey-validated journey-flow-check" title={title}>
      <input
        type="checkbox"
        checked={checked}
        disabled={Boolean(disabled) || (!checked && !onCheck)}
        onChange={() => {
          if (interactive) onCheck?.();
        }}
      />
      {label}
    </label>
  );
}

export function JourneySendFlow({
  isValidated,
  testCompleted,
  testCommenced,
  mappingReviewed,
  busy,
  audienceSendEnabled,
  onValidate,
  onTestSend,
  onMarkTestCompleted,
  onShowMappings,
  onMarkMappingReviewed,
  onSendAudience,
}: {
  isValidated: boolean;
  testCompleted: boolean;
  testCommenced: boolean;
  mappingReviewed: boolean;
  busy: boolean;
  audienceSendEnabled: boolean;
  onValidate: () => void;
  onTestSend: () => void;
  onMarkTestCompleted: () => void;
  onShowMappings: () => void;
  onMarkMappingReviewed: () => void;
  onSendAudience: () => void;
}) {
  return (
    <div className="journey-send-flow" aria-label="Send workflow">
      <div className="journey-flow-step">
        <button type="button" className="secondary journey-flow-btn" disabled={busy} onClick={onValidate}>
          {isValidated ? "Revalidate" : "Validate"}
        </button>
        <JourneyFlowGate
          label="Validated"
          checked={isValidated}
          disabled={busy}
          title={isValidated ? "Template passed SendGrid checks" : "Run Validate to enable test send"}
        />
      </div>

      <JourneyFlowArrow />

      <div className="journey-flow-step">
        <button
          type="button"
          className="secondary journey-flow-btn"
          disabled={busy || !isValidated}
          title={isValidated ? undefined : "Check Validated first"}
          onClick={onTestSend}
        >
          Test send
        </button>
        <JourneyFlowGate
          label="Test completed"
          checked={testCompleted}
          disabled={busy || !isValidated}
          title={
            testCompleted
              ? "Test send complete — mapping step unlocked"
              : testCommenced
                ? "Mark complete after reviewing the test email"
                : "Send a test email, then check to continue"
          }
          onCheck={testCommenced && !testCompleted ? onMarkTestCompleted : undefined}
        />
      </div>

      <JourneyFlowArrow />

      <div className="journey-flow-step">
        <button
          type="button"
          className="secondary journey-flow-btn"
          disabled={busy || !testCompleted}
          title={testCompleted ? undefined : "Complete test send first"}
          onClick={onShowMappings}
        >
          Show/Edit mappings
        </button>
        <JourneyFlowGate
          label="Mappings ready"
          checked={mappingReviewed}
          disabled={busy || !testCompleted}
          title={
            mappingReviewed
              ? "Mappings acknowledged — audience send unlocked"
              : "Review mappings, then check to enable audience send"
          }
          onCheck={testCompleted && !mappingReviewed ? onMarkMappingReviewed : undefined}
        />
      </div>

      <JourneyFlowArrow />

      <div className="journey-flow-step">
        <button
          type="button"
          className="journey-flow-btn journey-flow-btn-primary"
          disabled={busy || !audienceSendEnabled}
          title={audienceSendEnabled ? undefined : "Complete validate, test, and mappings first"}
          onClick={onSendAudience}
        >
          Send to audience
        </button>
      </div>
    </div>
  );
}
